/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Asset Vehicle Icon component.
 */
export const VehicleIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_14304_19309)'>
        <circle cx='7.33269' cy='16.8283' r='1.80681' stroke={iconColor} strokeWidth='1.5' />
        <circle cx='18.8976' cy='16.8283' r='1.80681' stroke={iconColor} strokeWidth='1.5' />
        <path d='M8.72334 16.8197H14.1891V5.60449C14.1891 5.05221 13.7414 4.60449 13.1891 4.60449H2C1.44772 4.60449 1 5.05221 1 5.60449V15.8197C1 16.372 1.44772 16.8197 2 16.8197H6.15406' stroke={iconColor} strokeWidth='1.5' />
        <path d='M14.1899 6.75781L19.1084 6.75781C19.4301 6.75781 19.7321 6.91254 19.92 7.17361L23.3115 11.8852C23.434 12.0553 23.4999 12.2597 23.4999 12.4694V16.8174H20.5918M14.1899 16.8174H17.0205' stroke={iconColor} strokeWidth='1.5' strokeLinejoin='round' />
      </g>
      <defs>
        <clipPath id='clip0_14304_19309'>
          <rect width={iconSize} height={iconSize} fill={dlsColor('white')} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default VehicleIcon;
